<template>
  <div class="accordion-container">
    <div class="accordion-item" v-for="(item, index) in initialData" :key="index">
      <!-- 红色头部区域 - 可点击 -->
      <div 
        class="accordion-header"
        :class="{ 'expanded': item.isExpanded }"
        @click="toggleItem(item,index,item.children)"
      >
      <div style="display: flex;">
          <img src="@/assets/image/airpaid.png" alt="" class="img-icon">
          <div class="header-content">
            <div class="header-title">{{ item.name }}</div>
            <div class="header-subtitle">共{{ item.doc_count || 0 }}条</div>
          </div>
      </div>
      </div>
      <!-- 绿色内容区域 - 展开时显示 -->
      <div 
        v-if="statusType == 'Book'"
        class="accordion-content"
        v-show="item.isExpanded"
        :class="{ 'show': item.isExpanded }"
      >
        <div class="content-list">
          <div 
            class="content-item" 
            :class="{ 'active': child.isActive }"
            v-for="child in item.children" 
            :key="child.key"
            @click="handleContentClick(item, child)"
          >
            {{ child.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionComponent',
  props: {
    initialData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      statusType: '',
      // 记录当前激活的子项，避免遍历所有数据
      activeChild: null
    }
  },
  created() {
    this.statusType = this.$route.query.type
    // 深拷贝初始数据，确保第一个默认展开
    // this.items = JSON.parse(JSON.stringify(this.initialData))
    // if (this.items.length > 0) {
    //   this.items[0].isExpanded = true
    // }
  },
  methods: {
    toggleItem(item,index,child) {
      if (['AudioBook', 'Course'].includes(this.statusType)) {
        this.initialData.forEach(currentItem => {
          currentItem.isExpanded = currentItem === item
        })
        this.$emit('toggle', {
          index: index,
          item: item,
          isExpanded: true
        })
        return
      }

      // 切换指定项的展开状态
      item.isExpanded = !item.isExpanded
      if(item.isExpanded){
        // 发射事件给父组件
        this.$emit('toggle', {
          index: index,
          item: item,
          isExpanded: item.isExpanded
        })
      } else {
        // 收起时，只重置当前项的激活子项
        if(this.activeChild && child && child.includes(this.activeChild)){
          this.activeChild.isActive = false
          this.activeChild = null
        }
        this.$emit('toggle')
      }
      
    },
    
    handleContentClick(item,child) {
      // 性能优化：只重置之前激活的子项，而不是遍历所有数据
      if (this.activeChild && this.activeChild !== child) {
        this.activeChild.isActive = false
      }
      
      // 设置当前点击的child为激活状态
      child.isActive = true
      this.activeChild = child
      
      // 处理内容项点击事件
      this.$emit('content-click', {
        child: child,
        item: item
      })
    },
    
    // 公共方法：展开指定项
    expandItem(index) {
      if (this.initialData[index]) {
        this.initialData[index].isExpanded = true
      }
    },
    
    // 公共方法：收起指定项
    collapseItem(index) {
      if (this.initialData[index]) {
        this.initialData[index].isExpanded = false
      }
    },
    
    // 公共方法：展开所有项
    expandAll() {
      this.initialData.forEach(item => {
        item.isExpanded = true
      })
    },
    
    // 公共方法：收起所有项
    collapseAll() {
      this.initialData.forEach(item => {
        item.isExpanded = false
      })
      // 重置激活的子项
      if (this.activeChild) {
        this.activeChild.isActive = false
        this.activeChild = null
      }
    },
    
    // 公共方法：重置所有激活状态
    resetActiveStates() {
      if (this.activeChild) {
        this.activeChild.isActive = false
        this.activeChild = null
      }
    }
  }
}
</script>

<style scoped>
.accordion-container {
  width: 100%;
  max-width: 290px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.accordion-item {
  margin-bottom: 10px;
}

.accordion-item:last-child {
  border-bottom: none;
}

.accordion-header {
  background: #f9fafb;
  color: #393359;
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  transition: all 0.3s ease;
  user-select: none;
  border-radius: 10px;
  text-align: center;

  .img-icon {
    width: 50px;
    margin-right: 12px;
  }
}

.accordion-header.expanded {
  background: #fdf3f3;
}

.header-content {
  flex: 1;
  margin-top: 4px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 2px;
}

.header-subtitle {
  font-size: 12px;
  opacity: 0.9;
      text-align: left;
}

.toggle-icon {
  font-size: 18px;
  font-weight: bold;
  width: 20px;
  text-align: center;
}

.accordion-content {
  border-top: none;
  max-height: 0;
  overflow: auto;
  transition: all 0.3s ease;
}

.accordion-content.show {
  max-height: 300px;
  padding: 8px 0;
}

.content-item {
  padding: 8px 12px;
  margin: 8px 0;
  background: #f9fafb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #333;
  text-align: center;
}
.active {
  background: #fdf3f3;
}

.content-item:hover {
  background: #fdf3f3;
}

.content-item:first-child {
  margin-top: 8px;
}

.content-item:last-child {
  margin-bottom: 8px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .accordion-container {
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }
  
  .header-title {
    font-size: 14px;
  }
  
  .header-subtitle {
    font-size: 11px;
  }
  
  .content-item {
    font-size: 13px;
  }
}
</style>